(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Vuex"), require("_"), require("Vue"));
	else if(typeof define === 'function' && define.amd)
		define(["Vuex", "_", "Vue"], factory);
	else if(typeof exports === 'object')
		exports["educational-training-management-sm"] = factory(require("Vuex"), require("_"), require("Vue"));
	else
		root["educational-training-management-sm"] = factory(root["Vuex"], root["_"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__5880__, __WEBPACK_EXTERNAL_MODULE__60bb__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 